import React from "react";
import styled from "styled-components";

export function NotFoundPage() {
    return (
        <NotFoundPageContainer>
            <p>404 | Not Found</p>
            <p>お探しのページは見つかりませんでした。</p>
        </NotFoundPageContainer>
    );
}

const NotFoundPageContainer = styled.div`
    padding-top: 32px;
`;
